import { ClinicSummary } from "./ClinicSummary";
import { RoomsGrid } from "./RoomsGrid";

/**
 * The Clinic View: the clinic's rooms as a grid. Shown in the main pane when no
 * room is selected (the default landing). The persistent Patient Flow rail
 * alongside lists all of today's visits, so the Clinic View is the clinic-wide
 * "everything" view; selecting a room drills into just that room.
 */
export const ClinicView = () => (
  <div className="flex flex-col gap-6">
    <ClinicSummary />
    <div className="flex flex-col gap-4">
      {/* No visible label - the tiles name themselves. The heading stays for
          screen-reader outline navigation. */}
      <h2 className="sr-only">Rooms</h2>
      <RoomsGrid />
    </div>
  </div>
);
